import i18n from '@i18n';
import { FuseNavItemType } from '@fuse/core/FuseNavigation/types/FuseNavItemType';
import ar from './navigation-i18n/ar';
import en from './navigation-i18n/en';
import tr from './navigation-i18n/tr';
import SettingsAppNavigation from '../pages/apps/settings/settings/SettingsAppNavigation';
import BillingAppNavigation from '../pages/apps/billing/BillingAppNavigation';

i18n.addResourceBundle('en', 'navigation', en);
i18n.addResourceBundle('tr', 'navigation', tr);
i18n.addResourceBundle('ar', 'navigation', ar);

/**
 * The navigationConfig object is an array of navigation items for the Fuse application.
 */
const navigationConfig: FuseNavItemType[] = [
	{
		id: 'dashboards.analytics',
		title: 'Dashboard',
		type: 'item',
		icon: 'heroicons-outline:chart-pie',
		url: '/dashboard'
	},
	{
		id: 'e-commerce-users',
		title: 'Users',
		type: 'item',
		url: '/apps/users',
		icon: 'heroicons-outline:user-group',
		end: true
	},
	{
		id: 'e-commerce-areas',
		title: 'Areas',
		type: 'item',
		url: '/apps/areas',
		icon: 'heroicons-outline:map',
		end: true
	},
	{
		id: 'apps.addresses',
		title: 'Addresses',
		type: 'item',
		url: '/apps/addresses',
		icon: 'heroicons-outline:map-pin'
	},
	{
		id: 'applications',
		title: 'My Assets',
		type: 'item',
		url: '/apps/applications',
		icon: 'heroicons-outline:clipboard-document-check',
		end: true
	},
	{
		id: 'apps.documents',
		title: 'Documents',
		type: 'item',
		url: '/apps/documents',
		icon: 'heroicons-outline:document-text'
	},
	{
		id: 'apps.transactions',
		title: 'Transactions',
		type: 'item',
		url: '/apps/transactions',
		icon: 'heroicons-outline:banknotes'
	},
	BillingAppNavigation,
	{
		...SettingsAppNavigation,
		type: 'item'
	}
];

export default navigationConfig;
